<template>
  <div>
    <GlSection class="report-token-list__wrapper">
      <template #title>
        <div class="report-token-list__title-wrapper">
          <div> Choose Token Report </div>
          <div
            class="choose-token__assets-link"
            @click="openTokensModal = true"
          >
            More
            <gl-icon
              :height="20"
              link
              name="arrow-forward-2"
              :width="20"
            />
          </div>
        </div>
      </template>

      <template #body>
        <div class="choose-token__wrapper">
          <div class="choose-token__list-wrapper">
            <div
              v-for="contract in displayTokensList"
              :key="contract.address"
              class="choose-token__chips"
              :class="[
                {
                  'choose-token__chips--selected':
                    selectedToken.address === contract.address,
                },
                { 'choose-token__chips--disabled': disable },
              ]"
              @click="selectToken(contract)"
            >
              <GlAvatar
                v-if="contract.address === 'all'"
                :avatar-list="getAvatarsList"
                label-in-list-key="symbol"
              />
              <GlAvatar
                v-else
                :avatar-list="[contract]"
                label-in-list-key="symbol"
              />
              <div class="choose-token__base-width bold-600 fs-14">
                {{
                  contract.symbol
                    ? trancateString(contract.symbol, 7)
                    : contract.symbol
                }}
              </div>
              <GlScoreLevelChip
                v-if="contract.score !== undefined && contract.score !== null"
                :level="contract.score"
                score
                small
              />
              <div
                v-if="contract.balance"
                class="fs-10 bold"
              >
                {{
                  toComaSeparate(
                    String(restrictNumberAfterComma(contract.balance, 8)),
                  )
                }}
              </div>
              <div
                v-if="contract.price"
                class="price fs-8"
              >
                {{ formatByPrice(contract.price) }}
              </div>
            </div>
          </div>
          <div>
            <div
              v-if="tokensList.length > displayTokensCount"
              class="choose-token__assets choose-token__base-width"
              @click="openTokensModal = true"
            >
              <div class="choose-token__assets-circle">
                <gl-icon
                  :height="16"
                  name="more-ellipsis"
                  :width="16"
                />
              </div>

              <div class="bold-600 fs-14">
                Other assets
              </div>
            </div>
          </div>
        </div>
      </template>
    </GlSection>

    <AssetsTokenModal
      v-show="openTokensModal"
      v-model="openTokensModal"
      :address-hash="addressHash"
      :disable="disable"
      :request-type="requestType"
      :selected-token="selectedToken"
      :tokens-list="tokensList"
      @close="openTokensModal = false"
      @select="selectToken"
    />
  </div>
</template>

<script>
// Components
import GlSection from '@/components/gl-section'
import GlAvatar from '@/components/gl-avatar.vue'
import GlIcon from '@/components/gl-icon.vue'
import GlScoreLevelChip from '@/components/gl-score-level-chip'
import AssetsTokenModal from '@/pages/report/components/token-report-2/AssetsTokenModal.vue'
// Utils
import { trancateString } from '@/utils/text-formatter'
import { getFirstLetter } from '@/utils/text-formatter'
import { toComaSeparate, restrictNumberAfterComma } from '@/utils/formatNumber'
import { formatByPrice } from '@/utils/format-by-price'

export default {
  components: {
    GlSection,
    GlAvatar,
    GlIcon,
    AssetsTokenModal,
    GlScoreLevelChip,
  },
  props: {
    displayTokensCount: {
      type: Number,
      default: 15,
    },
    tokensList: {
      type: Array,
      default: () => [],
    },
    selectedToken: {
      type: Object,
      default: () => ({}),
    },
    addressHash: {
      type: [String],
      default: '',
    },
    disable: {
      type: Boolean,
      default: false,
    },
    requestType: {
      type: String,
      default: 'address',
    },
  },
  data() {
    return {
      openTokensModal: false,
    }
  },
  computed: {
    displayTokensList() {
      return this.tokensList
        .slice(0, this.displayTokensCount)
        .filter(token => token.symbol.trim())
    },
    getAvatarsList() {
      return this.tokensList.filter(item => item.address !== 'all')
    },
  },
  methods: {
    trancateString,
    getFirstLetter,
    toComaSeparate,
    restrictNumberAfterComma,
    formatByPrice,
    selectToken(token) {
      if (!this.disable) {
        this.$emit('set-token', token)
      }
    },
  },
}
</script>
<style>
.report-token-list__wrapper {
  margin-bottom: 24px;
}
.report-token-list__title-wrapper {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.choose-token__wrapper {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
.choose-token__list-wrapper {
  display: flex;
  overflow-x: auto;
  margin-right: 8px;
  padding-bottom: 8px;
  gap: 8px;
}
.choose-token__list-wrapper::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.choose-token__chips {
  display: flex;
  flex-direction: column;
  padding: 12px;
  gap: 8px;
  color: var(--Basic-900);
  cursor: pointer;
  white-space: nowrap;
  border-radius: 16px;
  border: 1px solid var(--Basic-100, rgba(9, 21, 64, 0.04));
  background: var(--Basic-A-900, #fff);
}

.choose-token__chips:hover {
  border: 1px solid var(--dark-grey);
}

.choose-token__chips--selected {
  border: 1px solid var(--Brand-Main, #194bfb);
  background: var(--Brand-100, rgba(25, 75, 251, 0.1));
}

.choose-token__chips--disabled {
  border: 1px solid var(--dark-grey-6-e);
  color: var(--white);
  background-color: var(--pale-blue);
  cursor: not-allowed;
}

.choose-token__chips--disabled .gl-avatar__icon-wrapper {
  background-color: var(--pale-blue);
}
.choose-token__chips--disabled .gl-avatar__rest {
  color: var(--space-cadet);
}

.choose-token__chips-empty-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 2px solid var(--dark-grey);
  color: var(--space-cadet);
  border-radius: 50%;
  width: 20px;
  height: 20px;
  font-size: 12px;
  font-weight: 600;
}

.choose-token__assets {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  height: 100%;
  white-space: nowrap;
}

.choose-token__base-width {
  min-width: 88px;
}

.choose-token__assets-circle {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  width: 40px;
  border-radius: 8px;
  background: var(--Basic-200, rgba(9, 21, 64, 0.08));
}

.choose-token__assets-link {
  display: none;
  align-items: center;
  color: var(--Brand-Main, #194bfb);
  text-align: center;
  font-size: var(--Size-M, 14px);
  font-weight: 600;
  line-height: var(--Line-Height-L, 20px);
  letter-spacing: var(--Letter-Spacing-S, -0.2px);
  cursor: pointer;
}

@media (max-width: 767px) {
  .choose-token__assets-link {
    display: flex;
  }
  .choose-token__assets {
    display: none;
  }
  .report-token-list__wrapper {
    margin-bottom: 0;
    border-bottom: 1px solid var(--Basic-200, rgba(9, 21, 64, 0.08));
  }
}
</style>
